import { TagProps } from '@/components/Tag';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { getOcelotConfig } from 'lib/configs/ocelot';
import { ArticleFooter } from './ArticleFooter';
import { getCurrentBrand } from '@/utils/getCurrentBrand';
import { LinkProps } from '@/components/Link';
import { mergeOptions } from '@/utils/merge';

export interface StandaloneArticleFooterProps extends StandaloneComponentProps<typeof ArticleFooter> {
  tags?: TagProps[];
  disclaimer?: { text?: React.ReactNode; link?: undefined } | { text?: undefined; link?: LinkProps };
}

export const StandaloneArticleFooter: StandaloneComponent<StandaloneArticleFooterProps> = ({
  tags,
  disclaimer = {
    link: { href: '/redaktionell-policy' },
  },
  ...props
}) => {
  const disclaimerLink = disclaimer && 'link' in disclaimer ? disclaimer.link : undefined;
  const disclaimerContent =
    disclaimer && 'text' in disclaimer ? (
      disclaimer.text
    ) : (
      <>
        Vi baserar våra artiklar på verifierade källor, officiella uttalanden samt egna intervjuer.{' '}
        {getCurrentBrand().name} följer de pressetiska reglerna. Krönikor och analyser uttrycker skribentens egna
        åsikter.{' '}
        <ArticleFooter.DisclaimerLink
          {...disclaimerLink}
          options={mergeOptions(props.options?.$disclaimerLink, disclaimerLink?.options)}
        >
          Läs mer här.
        </ArticleFooter.DisclaimerLink>
      </>
    );

  return (
    <ArticleFooter {...props}>
      {getOcelotConfig('features.article.showNewsDisclaimer') && (
        <ArticleFooter.Disclaimer>
          <ArticleFooter.DisclaimerText>{disclaimerContent}</ArticleFooter.DisclaimerText>
        </ArticleFooter.Disclaimer>
      )}
      <ArticleFooter.Tags>
        {tags?.map((tag, index) => (
          <ArticleFooter.Tag
            key={index}
            value={tag.value}
            link={tag.link}
            options={props.options?.$tag}
            partOfList={true}
          />
        ))}
      </ArticleFooter.Tags>
    </ArticleFooter>
  );
};
